import { render } from "./SettingsEmailDomain.vue?vue&type=template&id=65289a2b"
import script from "./SettingsEmailDomain.vue?vue&type=script&lang=js"
export * from "./SettingsEmailDomain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__